import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/loan.module.css";
import AppIcons from "../../utils/appIcons";
import { Box, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import CustomSlider from "../customSlider";
import {
  calculateFlatInterestEMI,
  calculateReducingInterestEMI,
  emiAmountMarks,
  interestRateMarks,
  tenureMarks,
} from "../../utils/businessLoanUtil";
import { isTablet } from "../../utils/responsiveUtil";
import AppColors from "../../utils/appColors";
import EmiCalculatorResult from "./emiCalculatorResult";

function EmiCalculator() {
  const defaultAmount = emiAmountMarks[5];
  const defaultInterestRate = interestRateMarks[2];
  const defaultTenure = tenureMarks[3];

  const [amount, setAmount] = useState(defaultAmount?.displayValue);
  const [interestRate, setInterestRate] = useState(
    defaultInterestRate?.displayValue
  );
  const [tenure, setTenure] = useState(defaultTenure?.displayValue);
  const [flatIntEmi, setFlatIntEmi] = useState({
    emi: 0,
    totalInt: 0,
    totalAmt: 0,
  });
  const [reducingIntEmi, setReducingIntEmi] = useState({
    emi: 0,
    totalInt: 0,
    totalAmt: 0,
  });

  console.log("reducingIntEmi:", reducingIntEmi);

  useEffect(() => {
    const { emi, totalInterest, totalAmt } = calculateFlatInterestEMI(
      amount,
      interestRate,
      tenure
    );
    setFlatIntEmi({ emi, totalInt: totalInterest, totalAmt });

    const { redEmi, redTotalInterest, redTotalAmt } =
      calculateReducingInterestEMI(amount, interestRate, tenure);
    setReducingIntEmi({
      emi: redEmi,
      totalInt: redTotalInterest,
      totalAmt: redTotalAmt,
    });
  }, [amount, interestRate, tenure]);

  return (
    <Box className={styles.emiCalBg}>
      <Box className={`container`} position={"relative"}>
        <Box pt="40px" pb={"60px"} style={{ transform: "scale(0.92)" }}>
          <Box className={styles.flexColumnCenter}>
            <Typography className={styles.loanTitle}>
              {Strings.emiCalculatorTitle}
            </Typography>
            <Typography className={styles.loanDescription}>
              {Strings.emiCalculatorSubTitle}
            </Typography>
          </Box>
          <img
            src={AppIcons.imgEmiCalBanner}
            style={{ position: "absolute", right: 0, zIndex: 1 }}
            width={isTablet ? "100%" : "70%"}
          />

          <Box
            className={styles.emiCalWrapper}
            flexDirection={isTablet ? "column" : "row"}
          >
            {/* left section with slider */}
            <Box className={styles.emiLeftSection} mr={isTablet ? 0 : 8}>
              <CustomSlider
                title={"Loan Amount"}
                itemsList={emiAmountMarks}
                setCallback={setAmount}
                titleClass={styles.emiSliderTitle}
                defaultValue={defaultAmount?.value}
                tooltipColor={AppColors.white}
                sliderClasses={{
                  thumb: styles.emiSliderThumb,
                  rail: styles.emiSliderRail,
                  track: styles.emiSliderTrack,
                  mark: styles.emiSliderMark,
                  markLabel: styles.emiSliderMarkLabel,
                }}
              />
              <CustomSlider
                title={"Interest Rate"}
                itemsList={interestRateMarks}
                setCallback={setInterestRate}
                tooltipColor={AppColors.white}
                defaultValue={defaultInterestRate?.value}
                titleClass={styles.emiSliderTitle}
                sliderClasses={{
                  thumb: styles.emiSliderThumb,
                  rail: styles.emiSliderRail,
                  track: styles.emiSliderTrack,
                  mark: styles.emiSliderMark,
                  markLabel: styles.emiSliderMarkLabel,
                }}
              />
              <CustomSlider
                title={"Tenure"}
                itemsList={tenureMarks}
                setCallback={setTenure}
                defaultValue={defaultTenure?.value}
                tooltipColor={AppColors.white}
                titleClass={styles.emiSliderTitle}
                sliderClasses={{
                  thumb: styles.emiSliderThumb,
                  rail: styles.emiSliderRail,
                  track: styles.emiSliderTrack,
                  mark: styles.emiSliderMark,
                  markLabel: styles.emiSliderMarkLabel,
                }}
              />
            </Box>

            {/* divider */}
            {!isTablet && <Box mb={5} className={styles.graphDivider}></Box>}
           
            {/* right section */}
            <EmiCalculatorResult
              flatIntEmi={flatIntEmi}
              reducingIntEmi={reducingIntEmi}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default EmiCalculator;
